import { render } from "./MIInvestmentSummary.vue?vue&type=template&id=af3a215a&scoped=true"
import script from "./MIInvestmentSummary.vue?vue&type=script&lang=js"
export * from "./MIInvestmentSummary.vue?vue&type=script&lang=js"

import "./MIInvestmentSummary.vue?vue&type=style&index=0&id=af3a215a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af3a215a"

export default script